export const MUTE = 'canUnMute';
export const CAMERA = 'canToggleCamera';
export const SCREEN_SHARE = 'canScreenShare';
export const DIRECTOR_REQUEST_DENIED = 'denied';
export const DIRECTOR_REQUEST_ACCEPTED = 'accepted';
export const DIRECTOR_REQUEST_SENT = 'Request sent!';
export const DIRECTOR_REQUEST_CANCELLED = 'cancelled';
